import { render, staticRenderFns } from "./ManageQuestionPage.vue?vue&type=template&id=1df0c1b4&"
import script from "./ManageQuestionPage.vue?vue&type=script&lang=js&"
export * from "./ManageQuestionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports